import { Pipe, PipeTransform } from '@angular/core';
import { Translation } from '../models/entities/translation';

@Pipe({ name: 'keys' })
export class KeysPipe implements PipeTransform {
  transform(value: any): string[] {
    if (!value) {
      return [];
    }
    return Object.keys(value).sort((a, b) => parseInt(a, 10) - parseInt(b, 10));
  }
}
